// extracted by mini-css-extract-plugin
export default {"formInputWrapper":"style_formInputWrapper__rQDWP"};